export const stepOneData = [
  {
    heading: "Why Use MinEMI’s EMI Calculator for Home Loan Balance Transfers?",
    // paras before heading

    infoList: [
      {
        heading: " Accurate EMI Estimates: ",
        description:
          "Get precise monthly repayment calculations based on your loan amount, interest rate, and tenure.",
      },
      {
        heading: " Compare Loan Offers:",
        description:
          " Evaluate EMIs across different lenders and find the best offer for your home loan transfer.",
      },
      {
        heading: "Visualize Savings:",
        description:
          " Instantly see how much you can save on EMIs and total interest over the tenure.",
      },
      {
        heading: " Plan Efficiently:   ",
        description:
          "Simulate various repayment scenarios to make informed decisions.",
      },
      {
        heading: "Transparent and User-Friendly:   ",
        description:
          "MinEMI provides clarity on costs, savings, and processing fees to ensure a seamless experience.",
      },
    ],
    headingTwo:
      "What You Can Do With the Home Loan Balance Transfer EMI Calculator?",
    // paras before heading

    infoListTwo: [
      {
        heading: " Estimate Your New EMI:",
        description:
          "Input your outstanding loan amount, current and new interest rates, and tenure to calculate your revised EMI instantly.",
      },
      {
        heading: " Simulate Loan Scenarios: ",
        description:
          "Adjust variables such as loan amount, interest rate, or tenure to see their impact on your EMIs and total repayment costs.",
      },
      {
        heading: "Evaluate Savings:",
        description:
          "Calculate the difference in total repayment amounts to understand your overall savings from the balance transfer.",
      },
    ],
    minEmiTipHead: "Choose the Right Time for Balance Transfer",
    minemiTip: [
      {
        head: " Early Tenure:",
        info: " Maximum savings occur when you transfer your loan in the early stages of your tenure.",
      },
      {
        head: "Market Rate Reductions:",
        info: "If market interest rates drop and your lender hasn’t revised your terms, consider a transfer.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    minEmiTipHead: " Understand Hidden Costs",
    minemiTip: [
      {
        head: " Processing Fees:",
        info: " Typically 0.5%-1% of the loan amount. Ensure savings outweigh these fees.",
      },
      {
        head: " Prepayment Penalties: ",
        info: "Check if your current lender charges penalties for early closure.",
      },
      {
        head: "Legal and Valuation Charges: ",
        info: " Include these costs in your decision-making process.",
      },
    ],
    heading: "How to Maximize Savings on Your Home Loan EMI",

    infoList: [
      {
        heading: "Compare Multiple Lenders:",
        info: "Even a 0.5% reduction in interest rate can save you lakhs over the loan tenure.",
      },
      {
        heading: " Prepay Strategically:",
        info: "Use MinEMI’s Prepayment Calculator to understand how lump-sum payments can reduce your principal and EMIs.",
      },
      {
        heading: " Improve Your Credit Score:",
        info: "A higher credit score can qualify you for better interest rates and terms from lenders.",
      },
    ],
    minEmiTipHeadTwo: "Evaluate Repayment Flexibility",
    minemiTipTwo: [
      {
        head: "Shorter Tenures:",
        info: "Save on total interest costs by opting for shorter repayment periods.",
      },
      {
        head: "Longer Tenures: ",
        info: "Lower your monthly EMI to ease cash flow, but keep total interest costs in check.",
      },
    ],

    paraOne: "Take Control of Your Home Loan with MinEMI",
    paraTwo:
      "With MinEMI’s Home Loan Balance Transfer EMI Calculator, you can simplify your loan repayments, reduce EMIs, and save significantly. Start calculating today and make an informed financial decision!",
  },
];
